import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed, File, LeagueDocument, UntilDestroy } from '@mtgame/core';
import { takeUntil } from 'rxjs/operators';
import { SeoService } from '@core/services/seo.service';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from '@mtgame/ui';
import { LeagueDocumentsService } from '@core/services/league-document.service';


@UntilDestroy
@Component({
  selector: 'mtg-league-documents',
  templateUrl: './league-documents.component.html',
  styleUrls: ['./league-documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueDocumentsComponent implements OnInit, OnDestroy {
  leagueDocuments: LeagueDocument[] = [];

  constructor(
    private seoService: SeoService,
    private leagueDocumentsService: LeagueDocumentsService,
    private cdr: ChangeDetectorRef,
    private httpClient: HttpClient,
    private loaderService: LoaderService,
  ) {
  }

  ngOnInit(): void {
    this.leagueDocumentsService.documents$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(leagueDocuments => {
        this.leagueDocuments = leagueDocuments;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.seoService.reset();
  }


  downloadFile(file: File, event): any {
    event.preventDefault();

    this.loaderService.show();
    this.httpClient.get(file.path, {responseType: 'blob', withCredentials: false})
      .subscribe(response => {
        const fileUrl = URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = file.originalName;
        a.click();
        this.loaderService.hide();
      }, error => {
        this.loaderService.hide();
      });
  }

  getFileSize(fileSize: number): string {
    if (fileSize > 1000000) {
      return `${(fileSize / 1000000).toFixed(2)}\u00A0mb`;
    } else if (fileSize < 1000000 && fileSize > 1000) {
      return `${(fileSize / 1000).toFixed(0)}\u00A0kB`;
    } else {
      return `${fileSize}\u00A0b`;
    }
  }


  isPdf(file: File): boolean {
    return file.mimeType.toLowerCase() === 'application/pdf';
  }

  isImg(file: File): boolean {
    return file.mimeType.toLowerCase().startsWith('image/');
  }
}
